import React, { useEffect, useState } from 'react'
import useUrl from 'useUrl'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useCookies } from 'react-cookie'
import { request } from 'hooks/useApi'

const isProduction = process.env.NODE_ENV === 'production'
let allowTracking = false

export const withTracker = (WrappedComponent, options = {}) => {
  const HOC = (props) => {
    const { pathname, hash = '', search = '' } = useLocation()
    const { locale } = useIntl()
    const [cookies, setCookie, removeCookie] = useCookies(['CookieConsent'])
    const [missingCookieBot, setMissingCookieBot] = useState(false)

    useEffect(() => {
      if (!'CookieConsent' in cookies) {
        setMissingCookieBot(true)
        console.info('Prompting..')
      } else if (
        cookies.CookieConsent &&
        cookies.CookieConsent.indexOf('statistics:true') > -1
      ) {
        console.info('Initializing..')
        allowTracking = true
      } else {
        console.info('Skipping..')
      }
    }, [])

    const path = useUrl(locale, `${pathname}${hash}${search}`)

    if (missingCookieBot) {
      return (
        <React.Fragment>
          <CookieBot domainGroupId="2daedd54-89c3-472c-bc82-da75ddd427ae" />
          <WrappedComponent {...props} />
        </React.Fragment>
      )
    }

    return <WrappedComponent {...props} />
  }

  return HOC
}

export const track = (key, props) => {
  if (!isProduction || !allowTracking) {
    return
  }

}

export const trackDemoPlay = (key, props) => {
  request('/rest/v2/supplier/demo-track',
    {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          "action": key,
          "supplier_uid": props.supplier,
          "demo_uid": props.demo
        })
      }
    }
  );
}

export const trackingProps = (key, props) => ({
  onMouseDown: () => track(key, props),
  onTouchStart: () => track(key, props),
})
